<app-modal-header (closeModal)="close()" [isShowCloseBtn]="true"></app-modal-header>
<app-modal-body>
  <h1 class="fs-5 fw-semibold mb-2">{{ titleKey() | translate: { entity: entityLabel() } }}</h1>
  <p class="mb-0" [innerHTML]="descriptionHtml()"></p>
</app-modal-body>
<app-modal-footer classList="d-flex justify-content-center">
  <button type="button" class="btn btn-primary rounded-5 fw-medium" (click)="close()">
    {{ 'PLANNER_GUIDANCE_GOT_IT' | translate }}
  </button>
</app-modal-footer>
